import _ from 'lodash';
import { get } from '~/utils/adapi';
import clone from 'clone';
import moment from 'moment-timezone';

const SET_CONFIG = 'SET_CONFIG';
const SET_LOADING = 'SET_LOADING';

const prependBaseUrl = (base, url) => {
  if (!/^https?:\/\//i.test(url)) {
    return `${base}/${url}`;
  }
  return url;
};

const actions = {
  updateConfig({ commit }, platform) {
    commit(SET_LOADING, true);
    return get('config/public')
      .then(config => {
        config.design = config[platform].design;
        config.login_types = _.get(config[platform], 'login_types', ['email']);
        config.design.logo = prependBaseUrl(config.fam_url, config.design.logo);
        config.design.favicon = prependBaseUrl(config.fam_url, config.design.favicon);
        if (config.timezone) {
          moment.tz.setDefault(config.timezone);
        }
        commit(SET_CONFIG, { config: clone(config), error: null });
        commit(SET_LOADING, false);
      })
      .catch(error => {
        commit(SET_CONFIG, { error, config: {} });
        commit(SET_LOADING, false);
      });
  },
};

const mutations = {
  [SET_CONFIG](state, { config, error }) {
    state.config = config;
    state.error = error;
  },
  [SET_LOADING](state, loading) {
    state.loading = loading;
  },
};

export default {
  namespaced: true,
  state: {
    config: {},
    error: null,
    loading: false,
  },
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/store/modules/publicConfig.js